/**
 * Returns true if the current page is product detail page.
 */
import getPageType from "./getPageType";

export default () => getPageType() === 'product detail';